export default "/images/vendor/quill/icons/align-justify.svg?90285f1f11db1912e9645c4a5e525344";